import { ErrorHandler, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Red de seguridad para los deploys (TS569): cuando se publica una versión nueva,
 * los ficheros con hash de la anterior desaparecen del servidor. Una pestaña
 * abierta desde antes puede pedir una pantalla cuyo fichero ya no existe
 * (`ChunkLoadError`). Aquí se detecta y se recarga una vez para traer la versión
 * nueva, con una guarda temporal para no entrar en bucle.
 *
 * Mismo planteamiento que `pwa-chunk-error.handler.ts` de todosector-angular.
 */
@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  private static readonly RELOAD_TS_KEY = 'app-chunk-reload-ts';
  private static readonly MIN_INTERVAL_MS = 10_000;

  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);
    const isChunkError =
      /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module|error loading dynamically imported module/i.test(
        message
      );

    if (this.isBrowser && isChunkError && this.canReload()) {
      sessionStorage.setItem(ChunkErrorHandler.RELOAD_TS_KEY, String(Date.now()));
      console.warn('[app-update] Pantalla no disponible (deploy nuevo). Recargando…', error);
      document.location.reload();
      return;
    }

    console.error(error);
  }

  /** Evita bucles: como mucho una recarga cada MIN_INTERVAL_MS. */
  private canReload(): boolean {
    try {
      const last = Number(sessionStorage.getItem(ChunkErrorHandler.RELOAD_TS_KEY) || 0);
      return Date.now() - last > ChunkErrorHandler.MIN_INTERVAL_MS;
    } catch {
      return false;
    }
  }
}
